import { render, staticRenderFns } from "./HowWorks.vue?vue&type=template&id=2ae86786&scoped=true"
import script from "./HowWorks.vue?vue&type=script&lang=js"
export * from "./HowWorks.vue?vue&type=script&lang=js"
import style0 from "./HowWorks.vue?vue&type=style&index=0&id=2ae86786&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae86786",
  null
  
)

export default component.exports